// FuelLog GraphQL queries and mutations for 8base
import { gql } from '@apollo/client';

export const FUEL_LOGS_LIST = gql`
  query FuelLogsList($sort: [FuelLogSort!], $first: Int, $skip: Int) {
    fuelLogsList(sort: $sort, first: $first, skip: $skip) {
      items {
        id
        cost
        createdAt
        date
        deletedAt
        fuelStation
        gallons
        notes
        odometer
        updatedAt
     
        vehicle {
          id
          make
          model
          licensePlate
        }
      }
      count
    }
  }
`;

export const FUEL_LOG_GET = gql`
  query FuelLogGet($id: ID!) {
    fuelLog(id: $id) {
      cost
      createdAt
      date
      deletedAt
      fuelStation
      gallons
      notes
      odometer
      updatedAt
     
      vehicle {
        id
        make
        model
        licensePlate
      }
    }
  }
`;

export const FUEL_LOG_GET_LIST_FILTER = gql`
  query FuelLogGet($id: ID!) {
    fuelLogsList(filter: { id: { equals: $id } }) {
      items {
        id
        cost
        createdAt
        date
        deletedAt
        fuelStation
        gallons
        notes
        odometer
        updatedAt
        
        vehicle {
          id
          make
          model
          licensePlate
        }
      }
    }
  }
`;

export const FUEL_LOG_CREATE = gql`
  mutation FuelLogCreate($data: FuelLogCreateInput!) {
    fuelLogCreate(data: $data) {
      id
    }
  }
`;

export const FUEL_LOG_UPDATE = gql`
  mutation FuelLogUpdate($filter: FuelLogKeyFilter!, $data: FuelLogUpdateInput!) {
    fuelLogUpdate(filter: $filter, data: $data) {
      id
    }
  }
`;

export const FUEL_LOG_DELETE = gql`
  mutation FuelLogDestroy($filter: FuelLogKeyFilter!) {
    fuelLogDestroy(filter: $filter) {
      success
    }
  }
`; 